import React, { useState } from 'react';

import { workerNearbySearchLinkProps } from '../../../../LandingPage/digoServices';

import PriorityLinks from './PriorityLinks';

import css from './CustomLinksMenu.module.css';

const homeLinkConfig = intl => [
  {
    group: 'primary',
    text: intl.formatMessage({ id: 'TopbarDesktop.homeLink' }),
    type: 'internal',
    route: { name: 'LandingPage' },
  },
];

// DIGO: Workers get a nearby-search shortcut before the create-listing CTA.
const findWorkLinkConfigMaybe = (intl, showLink) =>
  showLink
    ? [
        {
          group: 'primary',
          text: intl.formatMessage({ id: 'TopbarDesktop.findWorkLink' }),
          type: 'internal',
          route: workerNearbySearchLinkProps(),
        },
      ]
    : [];

// DIGO: Link directly to EditListingPage to preserve ?listingType query param.
// showLink=true for any logged-in user who can create listings.
// createListingType pre-selects the correct listing type based on user role.
const createListingLinkConfigMaybe = (intl, showLink, createListingType, createListingLabel) =>
  showLink
    ? [
        {
          group: 'primary',
          text: createListingLabel || intl.formatMessage({ id: 'TopbarDesktop.createListing' }),
          type: 'internal',
          route: {
            name: 'EditListingPage',
            params: {
              slug: 'draft',
              id: '00000000-0000-0000-0000-000000000000',
              type: 'new',
              tab: 'details',
            },
            to: createListingType ? { search: `?listingType=${createListingType}` } : undefined,
          },
          highlight: true,
        },
      ]
    : [];

/**
 * Desktop topbar custom links. DIGO always shows these inline — a single
 * "À propos" link should not collapse into a Plus dropdown.
 *
 * @param {Object} props
 * @param {Array<Object>} [props.customLinks]
 * @param {Object} props.intl
 * @param {boolean} props.showCreateListingsLink
 * @param {boolean} [props.showFindWorkLink]
 * @param {string} [props.createListingType]
 * @param {string} [props.createListingLabel]
 * @returns {JSX.Element}
 */
const CustomLinksMenu = ({
  customLinks = [],
  intl,
  showCreateListingsLink,
  showFindWorkLink,
  createListingType,
  createListingLabel,
}) => {
  const [links, setLinks] = useState([
    ...homeLinkConfig(intl),
    ...findWorkLinkConfigMaybe(intl, showFindWorkLink),
    ...createListingLinkConfigMaybe(
      intl,
      showCreateListingsLink,
      createListingType,
      createListingLabel
    ),
    ...customLinks,
  ]);

  return (
    <div className={css.customLinksMenu}>
      <PriorityLinks links={links} priorityLinks={links} setLinks={setLinks} />
    </div>
  );
};

export default CustomLinksMenu;
